import React from "react";
import "./Resume.css";
import ResumeDiv from "./ResumeDiv";

function Resume(props) {
  function handleClick(e) {
    let divName = e.target.id || e.target.parentNode.id;

    props.handleCurrentContent(divName);
  }

  return (
    <div className="components" id="resume-div">
      <ResumeDiv
        heading="Skills"
        imageName="skills"
        handleClick={handleClick}
      />
      <ResumeDiv
        heading="Work_Experience"
        imageName="work-experience"
        handleClick={handleClick}
      />
      <ResumeDiv
        heading="Education"
        imageName="education"
        handleClick={handleClick}
      />
      {/* <ResumeDiv 
        heading="Volunteer_Experience"
        imageName="volunteer-experience"
        handleClick={handleClick}
      /> */}
    </div>
  );
}

export default Resume;
